/**
 * 车辆列表
 */
import { VEHICLELIST } from '../types';

export default {
    name: `${VEHICLELIST}`,
    path: '/vehicleList',
    component: () => import(/* webpackChunkName: 'vehicleList' */ '@/views/vehicleList/'),
    redirect: { name: `${VEHICLELIST}Index` },
    meta: {
        title: '车辆列表',
        savedPosition: { x: 0, y: 0 },
    },
    children: [
        {
            name: `${VEHICLELIST}Index`,
            path: 'index',
            component: () => import(/* webpackChunkName: 'vehicleList' */ '@/views/vehicleList/home/Home.vue'),
        },
        // 详情
        {
            name: `${VEHICLELIST}Detail`,
            path: 'detail/:id',
            component: () => import(/* webpackChunkName: 'customerList' */ '@/views/vehicleList/detail/Detail.vue'),
        },
    ],
};
